import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1>Payment System is comming Soon !</h1>

        </div>
    );
};

export default Payment;